var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-item',{staticClass:"q-ma-none q-pa-none"},[_c('q-item-section',[_c('q-item-label',{staticClass:"my-input text-h5 text-weight-bold text-primary"},[_vm._v(_vm._s(_vm.data.extras.fullValue)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }